import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { AutoComplete } from "primereact/autocomplete";
import { classNames } from "primereact/utils";
import { Checkbox } from "primereact/checkbox";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { allocationService } from "../../../services";
import moment from "moment";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { currencies } from "../../../common/util/constants";
import { confirmDialog } from "primereact/confirmdialog";

const ProjectAllocation = ({ save, updateData, editData, userAllocaionType, onClose, projectName, projectStart, projectEnd, projectId, onLoad, currentUserData, poStatus, projectPo }) => {
  const [selectedCurrency, setSelectedCurrency] = useState(currencies[0]);
  const [resourceAvailable, setResourceAvailable] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [allocationTypes, setAllocationTypes] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [fullAllocationDisabled, setFullAllocationDisabled] = useState(false);
  const [partialAllocationDisabled, setPartialAllocationDisabled] = useState(false);
  const [otAllocationDisabled, setOtAllocationDisabled] = useState(false);
  const [resourceRole, setResourceRole] = useState([]);
  const [allocationEndDate, setAllocationEndDate] = useState(null);
  let teamDataUser;

  const [selectedRowData, setSelectedRowData] = useState({});
  const [updateIsBillable, setUpdateIsBillable] = useState(false);
  const [updatePoNumber, setUpdatePoNumber] = useState(false);

  useEffect(() => {
    getAllocationType();
    getResourceRole(projectId);
  }, []);

  useEffect(() => {
    if (userAllocaionType) {
      setResourceAvailable(editData.availability);
      setUpdateIsBillable(editData.isBillable);
      formik.setFieldValue("startDate", new Date(editData.startDate));
      formik.setFieldValue("endDate", new Date(editData.endDate));
      if (editData.poNumber) {
        setUpdatePoNumber(true);
        setSelectedCurrency(editData.currency);
      }
      // if (editData.availability === 100) {
      //   formik.setFieldValue("alloc100", true);
      //   formik.setFieldValue("allocPartial", false);
      //   formik.setFieldValue("ot", false);
      // } else if (editData.availability === 0) {
      //   formik.setFieldValue("ot", true);
      //   formik.setFieldValue("allocPartial", false);
      //   formik.setFieldValue("alloc100", false);
      // } else {
      //   formik.setFieldValue("allocOther", editData.availability);
      //   formik.setFieldValue("allocPartial", true);
      //   formik.setFieldValue("ot", false);
      //   formik.setFieldValue("alloc100", false);
      // }

      if (editData.allocationType === 1) {
        formik.setFieldValue("alloc100", true);
        formik.setFieldValue("allocPartial", false);
        formik.setFieldValue("ot", false);
      } else if (editData.allocationType === 3) {
        formik.setFieldValue("ot", true);
        formik.setFieldValue("allocPartial", false);
        formik.setFieldValue("alloc100", false);
      } else {
        formik.setFieldValue("allocOther", editData.availability);
        formik.setFieldValue("allocPartial", true);
        formik.setFieldValue("ot", false);
        formik.setFieldValue("alloc100", false);
      }
      teamDataUser = [
        {
          name: editData.firstName.toUpperCase() + " " + editData.lastName.toUpperCase(),
          id: editData.userId,
          isBillable: editData.isBillable,
          designation: editData.userProjectRole,
        },
      ];
    } else {
      // formik.setFieldValue("startDate", new Date(projectStart));
      // formik.setFieldValue("endDate", new Date(projectEnd));
    }
  }, [editData]);

  const getAllocationType = () => {
    allocationService.getAllocationtypes().then((resp) => {
      setAllocationTypes(resp?.data?.data);
    });
  };

  const getResourceRole = (proId) => {
    allocationService.getAllResourceRole(proId).then((resp) => {
      setResourceRole(resp?.data?.data);
    });
  };

  const formik = useFormik({
    initialValues: {
      project: projectId,
      resourceRole: editData ? editData.allocationId : '',
      billingRate: editData ? editData.billingRate : '',
      allocation: 0,
      alloc100: false,
      allocOther: "",
      allocPartial: false,
      ot: false,
      startDate: "",
      endDate: "",
      user: editData ? currentUserData : "",
      reason: "",
      poNumberVal: editData ? editData.poNumber : '',
      expiryDate: editData ? new Date(editData.poExpiry) : '',
      poAmount: editData ? editData.poAmount : '',
    },
    validate: (data) => {
      let errors = {};
      if (Object.keys(editData).length === 0) {
        if (Object.keys(selectedRowData).length === 0) {
          errors.resourceRole = "please select role for this project*";
        }
      }
      if (!data.startDate) {
        errors.startDate = "Start Date is required*";
      }
      if (!data.endDate) {
        errors.endDate = "End Date is required*";
      }
      if (!userAllocaionType) {
        if (selectedUsers.length === 0) {
          errors.user = "Please select minimum one user*";
        }
      }
      if (data.endDate && data.startDate) {
        if (moment(data.startDate) > moment(data.endDate)) {
          errors.endDate = "End Date is must be above than start date";
        }
      }

      if (data.alloc100) {
        if (resourceAvailable < 100) {
          errors.alloc100 = "Allocation should not be greater than availablity (" + resourceAvailable + "%)";
        }
      }
      if (data.allocPartial) {
        let updateAllocPercentage = editData.percentage + editData.availability;
        if (parseInt(data.allocOther) > parseInt(updateAllocPercentage)) {
          errors.allocOther = "Allocation should not be greater than (" + updateAllocPercentage + "%)";
        }
      }
      if (updatePoNumber) {
        if (!data.poNumberVal) {
          errors.poNumberVal = "Po number is required*";
        }
      }
      return errors;
    },

    onSubmit: (data) => {
      formik.resetForm();
      if (editData.allocationId) {
        if (
          formik.values.alloc100 ||
          formik.values.allocOther > 0 ||
          formik.values.ot
        ) {
          if (projectEnd >= moment(data.endDate).format("YYYY-MM-DD")) {
            const dataobj = {
              id: editData.allocationId,
              allocationType: fetchAllocation(data),
              percentage: fetchPercentage(data),
              endDate: moment(data.endDate).format("YYYY-MM-DD"),
              isBillable: updateIsBillable,
              poNumber: data.poNumberVal,
              expiryDate: moment(data.expiryDate).format("YYYY-MM-DD"),
              poAmount: data.poAmount,
              currency: selectedCurrency.code,
            };
            updateData(dataobj);
          } else {
            onClose();
            toast.error("Allocation Start Date should be greater than or equal to Project Start Date! Allocation End Date should be less than or equal to Project End Date!");
          }
        } else {
          toast.error("Allocation percentage not selected properly");
        }
      } else {
        if (moment(selectedUsers.flat(1)[0].empDoj).format("YYYY-MM-DD") > moment(data.startDate).format("YYYY-MM-DD")) {
          toast.error("Allocation Start Date should be greater than or equal to Resource DOJ!");
        } else {
          if (moment(data.startDate).format("YYYY-MM-DD") >= projectStart && projectEnd >= moment(data.endDate).format("YYYY-MM-DD")) {
            const dataobj1 = {
              projectId: projectId,
              projectRoleId: selectedRowData?.id,
              billingRateId: selectedRowData?.billingRate[0]?.id,
              startDate: moment(data.startDate).format("YYYY-MM-DD"),
              endDate: moment(data.endDate).format("YYYY-MM-DD"),
              isBillable: updateIsBillable,
              allocationType: fetchAllocation(data),
              percentage: fetchPercentage(data),
              poNumber: data.poNumberVal,
              expiryDate: moment(data.expiryDate).format("YYYY-MM-DD"),
              poAmount: data.poAmount,
              currency: selectedCurrency.code,
              users: selectedUsers.flat(1),
            };
            createManagerAllocation(dataobj1);
          } else {
            onClose();
            toast.error("Allocation Start Date should be greater than or equal to Project Start Date! Allocation End Date should be less than or equal to Project End Date!");
          }
        }


      }
    },
  });

  const handleDateChange = (date) => {
    formik.setFieldValue("startDate", date);
    // formik.setFieldValue("endDate", "");
  };

  const createManagerAllocation = async (data) => {
    if (
      formik.values.alloc100 ||
      formik.values.allocOther > 0 ||
      formik.values.ot
    ) {
      try {
        allocationService.createManagerAllocation(data).then(
          (resp) => {
            if (resp.status) {
              onClose();
              onLoad();
              toast.success("User allocated successfully!");
            }
          },
          (err) => {
            toast.error(err.response.data.error);
          }
        );
      } catch (error) {
        toast.error("Unable to create allocation...");
      }
    } else {
      toast.error("Allocation percentage not selected properly");
    }
  };

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const fetchAllocation = (data) => {
    var code = "100";
    if (data) {
      if (data.alloc100) {
        code = "100";
      } else if (data.allocPartial) {
        code = "PT";
      } else if (data.ot) {
        code = "OT";
      } else {
        code = "";
      }
    }

    var result = allocationTypes.filter((obj) => {
      return obj.code === code;
    });
    return result[0]?.id;
  };

  const fetchPercentage = (data) => {
    var result = 0;
    if (data) {
      if (data.alloc100) {
        result = 100;
      } else if (data.allocPartial) {
        result = data.allocOther;
      } else {
        result = 0;
      }
    }
    return result;
  };

  const searchUser = (event) => {
    if (event.query.trim().length > 2) {
      const dataobj = {
        queryString: event.query.trim()
      };
      allocationService.getBUAllocatedUsers(dataobj).then((resp) => {
        const dataObj = resp.data.data.map((v, i) => ({
          ...v,
          name: resp.data.data[i].name + "(" + resp.data.data[i].ecn + ")",
        }));
        setFilteredUsers(dataObj);
      });
    }
  };

  const allocHandler = (e) => {
    formik.handleChange(e);
    if (!formik.values.allocPartial) {
      formik.values.allocOther = "";
    }
    switch (e.target.name) {
      case "allocPartial":
        formik.setFieldValue("alloc100", false);
        formik.setFieldValue("ot", false);
        break;
      case "alloc100":
        formik.setFieldValue("allocPartial", false);
        formik.setFieldValue("ot", false);
        if (editData) {
          formik.setFieldValue("allocOther", editData.availability);
        }
        break;
      case "ot":
        formik.setFieldValue("alloc100", false);
        formik.setFieldValue("allocPartial", false);
        break;
      default:
    }
  };

  const selectedUser = (e) => {
    let resourceAvailablity = e?.value?.availability;
    setResourceAvailable(resourceAvailablity);
    if (resourceAvailablity === 100) {
      formik.setFieldValue("alloc100", true);
      formik.setFieldValue("allocPartial", false);
      formik.setFieldValue("ot", false);
      setFullAllocationDisabled(false);
      setPartialAllocationDisabled(false);
      setOtAllocationDisabled(true);
    } else if (resourceAvailablity === 0) {
      formik.setFieldValue("ot", true);
      formik.setFieldValue("allocPartial", false);
      formik.setFieldValue("alloc100", false);
      setFullAllocationDisabled(true);
      setPartialAllocationDisabled(true);
      setOtAllocationDisabled(false);
    } else {
      formik.setFieldValue("allocOther", resourceAvailablity);
      formik.setFieldValue("allocPartial", true);
      formik.setFieldValue("ot", false);
      formik.setFieldValue("alloc100", false);
      setFullAllocationDisabled(true);
      setPartialAllocationDisabled(false);
      setOtAllocationDisabled(true);
    }
    let isDuplicate = false;
    let firstName = e.value.name.split(" ")[0];
    let lastName = e.value.name.split(" ")[1];
    let dataobj = [
      {
        name: firstName.charAt(0).toUpperCase() + firstName.slice(1) + " " + lastName.charAt(0).toUpperCase() + lastName.slice(1),
        id: e?.value?.id,
        isBillable: updateIsBillable,
        designation: e?.value?.designation,
        empDoj: e?.value?.doj,
        empExitDate: e?.value?.exitDate,
        availability: e?.value?.availability,
        photo: e?.value?.photo,
        allocations: e?.value?.allocations,
      },
    ];

    if (selectedUsers && dataobj.length > 0) {
      isDuplicate = selectedUsers.some((user) => user[0].id === dataobj[0].id);
    }

    let userInfo = localStorage.getItem("user");
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      if (userInfo?.id === dataobj[0].id) {
        toast.info("You cannot select yourself.");
        return;
      }
    }
    if (isDuplicate) {
      toast.info("You have already selected this user.");
    } else {
      setSelectedUsers([dataobj]);
    }
    formik.setFieldValue("user", "");
  };

  const handleBillable = (e) => {
    var selectedid = e.target.id;
    let updatedList = selectedUsers.map((item) => {
      if (item[0].id === selectedid) {
        item[0].isBillable = !item[0].isBillable;
        return item;
      }
      return item;
    });
    setSelectedUsers(updatedList);
  };

  const deleteSelectedUser = (data) => {
    setSelectedUsers([]);
  };

  const onCloseMethod = () => {
    onClose();
  }

  const onRowClick = (event) => {
    if (event.data.billingRate[0].rate > 0) {
      setUpdateIsBillable(true);
    }
    if (event.data.count === 0) {
      return; // Ignore clicks on disabled rows
    }
    formik.setFieldValue("startDate", new Date(event.data.startDate));
    formik.setFieldValue("endDate", new Date(event.data.endDate));
    setSelectedRowData(event.data);
  };

  const rowClass = (rowData) => {
    setAllocationEndDate(rowData.endDate ? rowData.endDate : null);
    const isDisabled = rowData.count === 0; // Check if count is 0
    const isSelected = Object.keys(editData).length === 0
      ? rowData?.id === selectedRowData?.id
      : rowData?.id === editData?.userProjectRoleId;
    return {
      'disabled-row': isDisabled, // Apply disabled class if count is 0
      'job-expended-row': isSelected // Apply selected class
    };
  }

  const rateBody = (rowData) => {
    return (<>{rowData?.billingRate[0]?.currency + " " + rowData?.billingRate[0]?.rate + " " + rowData?.billingRate[0]?.billingType?.title}</>);
  }


  /* Archive Role Here */
  const reviewActionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-2" tooltip="Delete Role" tooltipOptions={{ position: "top" }} onClick={(e) => deleteResourceRole(e, rowData)} />
      </React.Fragment>

    )
  }

  const deleteResourceRole = (e, rowData) => {
    confirmDialog({
      target: e.currentTarget,
      message: 'Are you sure you want to delete this role?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptClassName: "p-button-danger",
      acceptLabel: 'No',
      rejectLabel: 'Yes',
      reject: () => {
        let param = {
          id: rowData.id,
        };
        try {
          allocationService.deleteAllocationRole(param).then((resp) => {
            if (resp.status === 200) {
              const filteredData = resourceRole.filter(item => item.id !== rowData.id);
              setResourceRole(filteredData);
              toast.success("Role deleted successfully");
            }
            // onClose();
          })
        } catch (error) {

        }
      },
      accept: () => { }
    });
  }
  /* Archive Role Here */

  return (
    <div className="Allocation">
      <form onSubmit={formik.handleSubmit}>
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="name" className={classNames({ "p-error": isFormFieldValid("name") })}>
              Project*
            </label>
            <span className="p-float-label">
              <InputText disabled placeholder={projectName} value={projectName} />
            </span>
          </div>

          <div className="grid date-selection">
            <Accordion activeIndex={0} style={{ width: '100%' }}>
              <AccordionTab header="Resource Role & Rate">
                <DataTable dataKey="id" value={resourceRole} tableStyle={{ minWidth: '50rem' }} selectionMode="single" onRowClick={onRowClick} rowClassName={rowClass}>
                  <Column field="title" header="Role" headerStyle={{ width: "15rem" }}></Column>
                  <Column field="startDate" header="Start Date" headerStyle={{ width: "10rem" }}></Column>
                  <Column field="endDate" header="End Date" headerStyle={{ width: "10rem" }}></Column>
                  <Column field="count" header="No Of Position" headerStyle={{ width: "10rem" }}></Column>
                  <Column field="title" header="Rate" headerStyle={{ width: "12rem" }} body={rateBody}></Column>
                  <Column field="" header="Action" body={reviewActionBodyTemplate} bodyStyle={{ width: '60px' }}></Column>
                </DataTable>
              </AccordionTab>
            </Accordion>
            {getFormErrorMessage("resourceRole")}
          </div>

          <div className="grid date-selection">
            <div className="col">
              <div className="field">
                <label htmlFor="date">Allocation Date*</label>
                <span className="p-float-label">
                  <Calendar type="date" id="date" name="startDate" value={formik.values.startDate} onChange={(e) => handleDateChange(e.target.value)} dateFormat="dd/mm/yy" mask="99/99/9999" showIcon placeholder="Start Date" disabled={userAllocaionType} minDate={new Date(formik.values.startDate)} maxDate={new Date(formik.values.endDate)} />
                  {getFormErrorMessage("startDate")}
                </span>
              </div>
            </div>
            <div className="col">
              <div className="field">
                <label htmlFor="date">Allocation End Date*</label>
                <span className="p-float-label">
                  <Calendar type="date" id="date" name="endDate" value={formik.values.endDate} onChange={formik.handleChange} dateFormat="dd/mm/yy" mask="99/99/9999" showIcon placeholder="End Date" minDate={new Date(formik.values.startDate)} maxDate={new Date(allocationEndDate)} disabled={!formik.values.startDate} />
                  {getFormErrorMessage("endDate")}
                </span>
              </div>
            </div>
          </div>


          {/* tableStyle */}
          <div className="grid">
            <label htmlFor="name" className={classNames({ "p-error": isFormFieldValid("name") })}></label>
            <div className="col6">
              {!poStatus && projectPo != null && (
                <i className='pi pi-exclamation-triangle' style={{ color: 'red' }}> PO Number already applied on project</i>
              )}
              <div className="field-checkbox">
                <Checkbox className="mt-4" onChange={e => setUpdatePoNumber(e.checked)} checked={updatePoNumber} disabled={!poStatus && projectPo != null}></Checkbox>
                <label className="checkbox-label allocationSelection" htmlFor="alloc100">Add PO Number on allocation</label>

              </div>
            </div>
          </div>
          {updatePoNumber && (
            <div className="grid date-selection">
              <div className="col">
                <div className="field">
                  <label htmlFor="date">PO Number*</label>
                  <span className="p-float-label">
                    <InputText id="poNumberVal" name="poNumberVal" placeholder={formik.values.poNumberVal} value={formik.values.poNumberVal} onChange={formik.handleChange}
                    />
                    {getFormErrorMessage("poNumberVal")}
                  </span>
                </div>
              </div>
              <div className="col">
                <div className="field">
                  <label htmlFor="date">Expiry Date*</label>
                  <span className="p-float-label">
                    <Calendar id="expiryDate" name="expiryDate" value={formik.values.expiryDate} onChange={formik.handleChange} placeholder="Date" showIcon dateFormat="dd/mm/yy" />
                    {/* {getFormErrorMessage("expiryDate")} */}
                  </span>
                </div>
              </div>
              <div className="col">
                <div className="field">
                  <label htmlFor="date">Amount*</label>
                  <div className="grid">
                    <div className="col-4">
                      <div className="field-checkbox">
                        <Dropdown value={selectedCurrency} onChange={(e) => setSelectedCurrency(e.value)} options={currencies} optionLabel="name" optionValue="code" placeholder="Select Currency" className="w-full md:w-14rem" />
                      </div>
                    </div>
                    <div className="col-8">
                      <div className="field-checkbox">
                        <InputText max={100} value={formik.values.poAmount} onChange={formik.handleChange} className='inputPercentage' id="poAmount" name="poAmount" />
                      </div>
                      {/* {getFormErrorMessage("poAmount")} */}
                    </div>
                  </div>


                </div>
              </div>
            </div>
          )}
        </div>

        {userAllocaionType && (
          <div>
            <div className="user-container">
              {currentUserData && currentUserData?.map((item, i) => {
                return (
                  <div>
                    <div className="grid">
                      <div className="col-2">
                        <div className="flex align-items-center gap-2">
                          {editData?.photo === "" ||
                            editData?.photo === null ? (
                            <span className="photo-span" style={{ height: "35px", width: "35px", borderRadius: "50%", border: "2px solid #d7e9ff", display: "flex", alignItems: 'center', justifyContent: 'center', fontSize: "18px", fontWeight: "600", color: "#1369b6", padding: '5px', paddingTop: '1px' }}>
                              {editData.firstName.toUpperCase().substr(0, 1)}
                              {editData.lastName.toUpperCase().substr(0, 1)}
                            </span>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                      <div className="col-6">
                        <span className="userName capitalize"> <b> {item.name}</b>{" "} </span>
                        <br />
                        <span className="userName"> <div> {item.designation} </div> </span>
                        <span className="userName">Availability :<b> {editData.availability} %</b> </span>
                      </div>
                      <div className="col-4">
                        <div className="grid">
                          <div className="col-3 mt-2">
                            {/* <Checkbox onChange={e => setUpdateIsBillable(e.checked)} checked={updateIsBillable}></Checkbox> */}
                            <Checkbox checked={updateIsBillable} disabled></Checkbox>
                          </div>
                          <div className="col-3 mt-2">Billable</div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {Object.keys(editData).length === 0 && (
          <div>
            <div className="field">
              <div className="p-fluid">
                <label htmlFor="name" className={classNames({ "p-error": isFormFieldValid("name") })}>
                  Resource*
                </label>
                <span className="p-float-label mt-2">
                  <AutoComplete value={formik.values.user} virtualScrollerOptions={{ itemSize: 38 }} name="user" placeholder="Search user" suggestions={filteredUsers} completeMethod={searchUser} field="name" aria-label="users" dropdownAriaLabel="Select user" onSelect={(e) => selectedUser(e)} onChange={formik.handleChange} appendTo="self" />
                </span>
                {getFormErrorMessage("user")}
              </div>
            </div>
            <div>
              {selectedUsers && selectedUsers.length >= 1 && (
                <div>
                  {selectedUsers.map((item, i) => {
                    return (
                      <div key={i + "selectedUsers"}>
                        <div className="user-container">
                          <div className="grid">
                            <div className="col-8">
                              <span className="userName"> <b> {item[0].name}</b>{" "} </span>
                              <br />
                              <span className="userName"> <div> {item[0].designation} </div> </span>
                              <span className="userName">Availability :<b> {item[0].availability} %</b> </span>
                            </div>
                            <div className="col-4">
                              <div className="grid">
                                <div className="col-3 mt-2">
                                  {/* <Checkbox id={item[0].id} name={item[0].name} checked={item[0].isBillable} onChange={handleBillable} /> */}
                                  <Checkbox id={item[0].id} name={item[0].name} checked={updateIsBillable} disabled />
                                </div>
                                <div className="col-3 mt-2">Billable</div>
                                <div className="col-2 mt-1">
                                  <Button icon="pi pi-times" type="button" className="p-button-rounded p-button-danger p-button-outlined userButton" onClick={(item) => deleteSelectedUser(item)} />
                                </div>
                              </div>
                            </div>
                          </div>
                          <Accordion activeIndex={null}>
                            <AccordionTab header="Current Allocation">
                              <DataTable value={item[0].allocations} responsiveLayout="scroll">
                                <Column field="id" header="ID" style={{ minWidth: "5rem" }}></Column>
                                <Column field="project" header="Project" style={{ minWidth: "15rem" }}></Column>
                                <Column field="percentage" header="Allocation(%)" style={{ minWidth: "8rem" }}></Column>
                              </DataTable>
                            </AccordionTab>
                          </Accordion>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}

        <div className="grid mt-2">
          <label htmlFor="name" className={classNames({ "p-error": isFormFieldValid("name") })}></label>
          <div className="col-4">
            <div className="field-checkbox">
              <Checkbox className="mt-4" id="alloc100" name="alloc100" checked={formik.values.alloc100} onChange={allocHandler} disabled={fullAllocationDisabled} />
              <label className="checkbox-label allocationSelection" htmlFor="alloc100"> 100% Allocation </label>
            </div>
          </div>
          <div className="col-5">
            <div className="field-checkbox">
              <Checkbox className="mt-4" id="allocPart" name="allocPartial" checked={formik.values.allocPartial} onChange={allocHandler} disabled={partialAllocationDisabled} />
              <label className="checkbox-label allocationSelection" htmlFor="allocPart"> Partial Allocation </label>
            </div>
          </div>
          <div className="col-3">
            <div className="field-checkbox mr-4">
              <Checkbox className="mt-4" id="allocOt" name="ot" checked={formik.values.ot} onChange={allocHandler} disabled={otAllocationDisabled} />
              <label className="checkbox-label ml-3 allocationSelection" htmlFor="allocOt"> OT </label>
            </div>
          </div>
          {getFormErrorMessage("alloc100")}
        </div>

        {formik.values.allocPartial && (
          <div className="partial-container">
            <div className="grid mt-3">
              <div className="col-4">
                <label htmlFor="other">Partial Allocation %</label>
              </div>
              <div className="col-8">
                <InputText id="allocOther" name="allocOther" style={{ width: "50px" }} value={formik.values.allocOther} onChange={(e) => {
                  if (e.target.value < 100) {
                    formik.handleChange(e);
                  }
                }}
                />
              </div>
              {getFormErrorMessage("allocOther")}
            </div>
          </div>
        )}
        <div className="" style={{ textAlign: "right", paddingTop: "25px" }}>
          <Button type="button" label="Cancel" className="p-button-rounded p-button-secondary" onClick={onCloseMethod} />
          <Button type="submit" label="Allocate Now" className="p-button-rounded ml-2" />
        </div>
      </form>
    </div>
  );
};
export default ProjectAllocation;
